import { showNotification } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";

import { authPost } from "@shared/api";
import { ApiError, OrgData } from "@shared/types";
import { queryClient } from "@shared/utils";

const createDeployment = async (
  deployment_name: string,
  source_type: string,
  source_id?: string
): Promise<OrgData> => {
  return authPost<
    { deployment_name: string; source_type: string; source_id?: string },
    { deployment: OrgData }
  >("/api/agent/deployments", { deployment_name, source_type, source_id }).then(
    (response) => {
      return response.deployment;
    }
  );
};

export const useCreateDeploymentMutation = () => {
  return useMutation({
    mutationFn: (options: {
      deploymentName: string;
      sourceType: string;
      sourceId?: string;
    }) =>
      createDeployment(
        options.deploymentName,
        options.sourceType,
        options.sourceId
      ),
    onError: (err: ApiError, options) => {
      showNotification({
        message:
          err.message ||
          `There was an issue creating the organization "${options.deploymentName}".`,
      });
    },
    onSuccess: () => {
      // NOTE: Coupling with the `useUserOrgs` hook, we invalidate the current user's orgs
      queryClient.invalidateQueries({ queryKey: ["userDeployments"] });
    },
  });
};
